import { render, staticRenderFns } from "./MortgageStatusListing.vue?vue&type=template&id=2c54e5ef"
import script from "./MortgageStatusListing.vue?vue&type=script&lang=js"
export * from "./MortgageStatusListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports